import CountryIso from "@/lib/countryIso";
import DateTimeUtils from "@/lib/dateTimeUtils";
import ListUtils from "@/lib/listUtils";
import ContactLocationDto from "../ContactLocations/ContactLocationDto";
import GeoPoint from "../Shared/GeoPoint";
import InPersonInterviewAddressType from "./InPersonInterviewAddressType";
import JobWorkerInterviewType from "./JobWorkerInterviewType";

export default class CreateJobWorkerInterviewViewModel {
    jobWorkerId = '';
    date: string = DateTimeUtils.getTodayAsIso().substring(0,10);
    startAtTime = '00:00';
    endAtTime = '00:00';
	type: JobWorkerInterviewType = JobWorkerInterviewType.Telephone;
    selectedContactLocation: ContactLocationDto = new ContactLocationDto();
    inPersonAddressType: InPersonInterviewAddressType = InPersonInterviewAddressType.JobLocation;
    otherLocationId = '';
    companyAddressId = '';
    buildingNameNumber = '';
    streetRoadBlock = '';
    locality = '';
    cityTown = '';
    stateProvinceRegion = '';
    postZipCode = '';
    country: CountryIso = new CountryIso();
    countryCode = '';
    geometry: GeoPoint = new GeoPoint();
    isExactGeo: boolean;
    addressSearchText = '';
    workerInstructions = '';
    contactInstructions = '';
    sendWorkerConfirmation = true;
    sendContactConfirmation = true;
}